import { Column } from '@synqo/frontend-component-library';
import { ApiConstructionSite } from '@Model';

export const constructionSiteColumns: Column<ApiConstructionSite>[] = [
    { name: 'label', label: 'Name' },
    { name: 'shorthand', label: 'Beschreibung' },
];
